import { cn } from "@deputy-ai/common";
import { Button, type ButtonProps } from "@deputy-ai/ui/button/Button";
import { useTranslations } from "next-intl";
import type { DetailedHTMLProps, HTMLAttributes } from "react";
import { IoChevronBack, IoClose } from "react-icons/io5";

export function WebChatHeaderUI(
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    backButton?: React.ReactNode;
    icon?: string;
    title?: string;
    subtitle?: string;
    endButton?: React.ReactNode;
    toggleHeader?: React.ReactNode;
  }
) {
  const {
    icon,
    title,
    subtitle,
    backButton = <BackButtonUI />,
    endButton = <EndButtonUI />,
    toggleHeader = <ToggleHeaderUI />,
  } = props;
  return (
    <div className="xsm:rounded-xl xsm:rounded-b-none xsm:pr-4 webchat-header flex h-14 flex-row items-center bg-black text-white">
      <div className="w-8">{backButton}</div>
      <div className={cn("flex flex-1 gap-1 px-0 py-4")}>
        {icon && (
          <>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className="h-6" src={icon} alt="icon" />
          </>
        )}
        <div className="flex grow flex-col gap-1">
          {title && <h1 className="title font-bold">{title}</h1>}
          {subtitle && (
            <p className="subtitle text-xs text-gray-200">{subtitle}</p>
          )}
        </div>
      </div>
      {endButton}
      {toggleHeader}
    </div>
  );
}

export function BackButtonUI(
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
  const { className, ...restProps } = props;
  return (
    <div className={cn(btnStyle, className)} {...restProps}>
      <div className={btnWrapperStyle}>
        <IoChevronBack />
      </div>
    </div>
  );
}

export function ToggleHeaderUI(
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    toggleVisible?: () => void;
  }
) {
  const { className, toggleVisible, ...restProps } = props;
  return (
    <div
      className={cn(btnStyle, "xsm:hidden pr-2 pl-4", className)}
      {...restProps}
    >
      <div className={btnWrapperStyle} onClick={toggleVisible}>
        <IoClose />
      </div>
    </div>
  );
}

export function EndButtonUI(props: ButtonProps) {
  const { variant = "outline", ...restProps } = props;
  const t = useTranslations("Webchat");

  return (
    <Button variant={variant} {...restProps}>
      {t("end_chat")}
    </Button>
  );
}

const btnStyle =
  "text-white cursor-pointer h-full flex items-center justify-center";
const btnWrapperStyle = "p-2";
